(function () {

  function formatMoney(cents, currency){
    try {
      return new Intl.NumberFormat(undefined,{
        style:'currency',
        currency:currency
      }).format(cents/100);
    } catch(e){
      return (cents/100).toFixed(2);
    }
  }

  async function getCart(){
    const r = await fetch('/cart.js');
    return await r.json();
  }

  async function updateBar(){

    const bars = document.querySelectorAll('[data-free-ship]');
    if(!bars.length) return;

    const cart = await getCart();

    bars.forEach(bar=>{

      const goal = Number(bar.dataset.goalCents);
      const total = cart.total_price;
      const currency = bar.dataset.currency || cart.currency;

      const fill = bar.querySelector('[data-free-ship-fill]');
      const text = bar.querySelector('[data-free-ship-text]');

      if(!fill || !text) return;

      const percent = Math.min((total/goal)*100,100);
      fill.style.width = percent+'%';

      if(total >= goal){
        text.innerHTML = "🎉 You unlocked free shipping!";
      }else{
        const left = goal-total;
        text.innerHTML = `Free shipping is only ${formatMoney(left,currency)} away!`;
      }

    });
  }

  document.addEventListener('DOMContentLoaded',updateBar);

  // Dawn reloads cart HTML → observe
  const obs = new MutationObserver(()=>{
    clearTimeout(window.__fsTimer);
    window.__fsTimer = setTimeout(updateBar,150);
  });

  document.addEventListener('DOMContentLoaded',()=>{
    obs.observe(document.body,{childList:true,subtree:true});
  });

})();
